function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  opacity: 0.4,
  d: "M10.9608 2.11001L5.46078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4408 5.82001 19.5808 4.57001 18.5308 4.18001L13.0308 2.12001C12.4708 1.90001 11.5308 1.90001 10.9608 2.11001Z",
  fill: "white",
  fillOpacity: 0.4
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.5 10.5C14.5 9.12 13.38 8 12 8C10.62 8 9.5 9.12 9.5 10.5C9.5 11.62 10.24 12.55 11.25 12.87V15.5C11.25 15.91 11.59 16.25 12 16.25C12.41 16.25 12.75 15.91 12.75 15.5V12.87C13.76 12.55 14.5 11.62 14.5 10.5Z",
  fill: "white",
  fillOpacity: 0.4
});

var SvgSecurityDark = function SvgSecurityDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSecurityDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Security_dark.82826a4c.svg";
export { ForwardRef as ReactComponent };